import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import {Print} from '@mui/icons-material';
import Loading from 'components/Loading';
import { Dropdown } from "antd"
import { useMobileDetect, useTabletDetection } from 'containers/chat/hooks';
import * as Sentry from '@sentry/react';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

export default function LessionPlanPrinter({images,onPrintSingle , printLoader, currentImage}) {
  const showAlert = useAlert();
  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;
   const [loader,setLoader]  = useState(false)
  const generatePDF = async () => {
    try {
      const { default: jsPDF } = await import('jspdf');
      const pageWidth = 215.9;
      const pageHeight = 279.4;

      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [pageWidth, pageHeight]
      });

      const loadImage = async (url) => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return URL.createObjectURL(blob);
        } catch (error) {
          Sentry.captureException(`235 Error loading image from URL ${url}: ${error}`);
          console.error(`Error loading image from URL ${url}:`, error);
          return null;
        }
      };

      const addImagesToPDF = async () => {
        let isFirstPage = true;
        for (const imageUrl of images) {
          const imageSrc = await loadImage(imageUrl);
          if (imageSrc) {
            if (!isFirstPage) pdf.addPage();
            isFirstPage = false;

            // ✅ Full bleed: 0 margin
            pdf.addImage(imageSrc, 'JPEG', 0, 0, pageWidth, pageHeight);
          }
        }

        // Optional cleanup
        if (pdf.internal.getNumberOfPages() > images.length) {
          pdf.deletePage(1);
        }

        printPDF(pdf.output('blob'));
      };

      setLoader(true);
      await addImagesToPDF();
      setLoader(false);
    } catch (error) {
      Sentry.captureException(`236 Error generating PDF: ${error}`);
      console.error("Error generating PDF:", error);
      showAlert("Something went wrong!", 'error');
    }
  };

  const generateSinglePagePDF = async () => {
    try {
      if (!currentImage) {
        if (typeof onPrintSingle === 'function') {
          onPrintSingle();
        }
        return;
      }

      const { default: jsPDF } = await import('jspdf');
      const pageWidth = 215.9;
      const pageHeight = 279.4;
      const pdf = new jsPDF({ orientation: 'p', unit: 'mm', format: [pageWidth, pageHeight] });

      const loadImage = async (url) => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return URL.createObjectURL(blob);
        } catch (error) {
          Sentry.captureException(`LP single image load error ${url}: ${error}`);
          return null;
        }
      };

      setLoader(true);
      const imageSrc = await loadImage(currentImage);
      if (imageSrc) {
        pdf.addImage(imageSrc, 'JPEG', 0, 0, pageWidth, pageHeight);
        printPDF(pdf.output('blob'));
      } else {
        showAlert("Unable to load image for printing", 'error');
      }
      setLoader(false);
    } catch (error) {
      Sentry.captureException(`LP single PDF error: ${error}`);
      setLoader(false);
      showAlert("Something went wrong!", 'error');
    }
  };

    const printPDF = (pdfBlob) => {
        if (pdfBlob) {
            const pdfUrl = URL.createObjectURL(pdfBlob);
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = pdfUrl;

            // Append the iframe to the body and print
            document.body.appendChild(iframe);

            // Wait for the iframe to load and then print
            iframe.onload = () => {
                iframe.contentWindow.print();

                // Remove the iframe after printing
                setTimeout(() => {
                    document.body.removeChild(iframe);
                    URL.revokeObjectURL(pdfUrl);
                }, 100000);
            };
        }
    };
    const userNav = () => {
        return {
            items: [
                {
                    key: 'single',
                    label: 'Print this page',
                    onClick: (info) => {
                        try {
                            // Ensure dropdown click does not interfere with printing
                            if (info && info.domEvent) {
                                info.domEvent.preventDefault();
                                info.domEvent.stopPropagation();
                            }
                            // Defer to next tick so the dropdown can close before print
                            setTimeout(() => {
                                generateSinglePagePDF();
                            }, 0);
                        } catch (error) {
                            Sentry.captureException(`LP single print click error: ${error}`);
                        }
                    }
                },
                {
                    key: 'entire',
                    label: 'Print entire lesson plan',
                    onClick: generatePDF
                }
            ]
        };
    };

    return (
      isMobile ||isTablate  ?
      <IconButton aria-label="print" 
            onClick={e => {
                e.preventDefault();
                if (isMobile || isTablate) {
                  showAlert("Print is not supported on this device!", 'error');
                  return;
                }
                }}   
                >
                {loader || printLoader ? <Loading size={20} /> : <Print />}
            </IconButton>
            :
        <Dropdown 
            disabled={loader||printLoader} 
            className='print-lession-plan' 
            menu={userNav()}  
            placement="top"
            trigger={['click','touch']}
        >
            <IconButton aria-label="print" 
              onTouchStart={(e) => e.preventDefault()}
              onClick={e => {
                e.preventDefault();
                if (isMobile || isTablate) {
                  showAlert("Print is not supported on this device!", 'error');
                  return;
                }
                }}   
                >
                {loader || printLoader ? <Loading size={20} /> : <Print />}
            </IconButton>
        </Dropdown>
      
    )
}

